import CloseButton from "@/components/modal/CloseButton";
import Modal from "@/components/modal/Modal";
import { H3 } from "@/components/typography";
import { useProjectQuery } from "@/queries";
import { route } from "@/utils/route_utils";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import ProjectUpdateForm from "./ProjectUpdateForm";
const ProjectUpdateEdit = () => {
  const history = useHistory();
  const { slug } = useParams();
  const { data: project } = useProjectQuery(slug);
  const handleClose = () => history.push(route("project", { slug }));
  return /* @__PURE__ */ React.createElement(Modal, { isVisible: true, onClose: handleClose, noPadding: true, cssClasses: "project-updates-modal" }, /* @__PURE__ */ React.createElement("div", { className: "px-4" }, /* @__PURE__ */ React.createElement("div", { className: "flex items-start justify-end" }, /* @__PURE__ */ React.createElement(CloseButton, { onClose: handleClose })), /* @__PURE__ */ React.createElement(H3, { className: "mt-0 text-center" }, "Edit Update"), /* @__PURE__ */ React.createElement("div", { className: "bg-white p-2 rounded mb-4" }, project && /* @__PURE__ */ React.createElement(ProjectUpdateForm, { project }))));
};
export default ProjectUpdateEdit;
